// extracted by mini-css-extract-plugin
export default {"containerAvatar":"UserAvatarMenu__containerAvatar___Wc50e","arrow":"UserAvatarMenu__arrow___CKesZ"};